import firebase from '@firebase/app'
import '@firebase/firestore'

const config = {
  apiKey: "AIzaSyA0uYpJWO-OiWbk82wUBa-2F61StmKqBrw",
  authDomain: "peamoni.firebaseapp.com",
  databaseURL: "https://peamoni.firebaseio.com",
  projectId: "peamoni",
  storageBucket: "peamoni.appspot.com",
  messagingSenderId: "741949965984",
  appId: "1:741949965984:web:a8736233c99755cde46bc5",
  measurementId: "G-M433FXLHZM"
}

firebase.initializeApp(config)
firebase.analytics();

const db = firebase.firestore()

export default db